import { FileText, Play, X } from 'lucide-react';
import { Tooltip } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import { formatBytes, isVideo, type PendingFile } from './chat-lib';
import styles from '../TicketChat.module.css';

export const PendingStrip: React.FC<{
  pending: PendingFile[];
  onRemove: (localId: string) => void;
  onPreview?: (localId: string) => void;
}> = ({ pending, onRemove, onPreview }) => {
  if (pending.length === 0) return null;
  return (
    <div className={styles.pendingStrip}>
      {pending.map((p) => (
        <div
          key={p.localId}
          className={cn(styles.pendingItem, p.status === 'error' && styles.pendingError)}
          title={p.status === 'error' ? p.error : p.file.name}
        >
          {p.previewUrl ? (
            <button
              type="button"
              className={styles.pendingThumbBtn}
              onClick={() => onPreview?.(p.localId)}
              aria-label={`Открыть «${p.file.name}»`}
            >
              {isVideo(p.file.type) ? (
                <>
                  <video className={styles.pendingThumb} src={p.previewUrl} muted preload="metadata" />
                  <span className={styles.pendingPlayBadge} aria-hidden>
                    <Play size={13} fill="currentColor" />
                  </span>
                </>
              ) : (
                <img className={styles.pendingThumb} src={p.previewUrl} alt={p.file.name} />
              )}
            </button>
          ) : (
            <div className={styles.pendingFile}>
              <FileText size={18} />
              <span>
                <div className={styles.fileName}>{p.file.name}</div>
                <div className={styles.fileSize}>{formatBytes(p.file.size)}</div>
              </span>
            </div>
          )}
          {p.status === 'uploading' && (
            <div className={styles.pendingProgress}>
              <span style={{ width: `${p.progress}%` }} />
            </div>
          )}
          <Tooltip content="Убрать файл">
            <button
              type="button"
              className={styles.pendingRemove}
              onClick={() => onRemove(p.localId)}
              aria-label={`Убрать файл ${p.file.name}`}
            >
              <X size={13} aria-hidden />
            </button>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};
